import HorizontalLayout from "components/HorizontalLayout";
import NonAuthLayout from "components/NonAuthLayout";
import VerticalLayout from "components/VerticalLayout";
import ScanRow from "pages/ ScanTheRow/Main/ScanRow";
import ScanSendOrderRow from "pages/ ScanTheRow/Main/ScanSendOrderRow";
import ListAllocateCollector from "pages/AllocateCollector/ListAllocateCollector";
import ListAllocateRunner from "pages/AllocateRunners/ListAllocateRunner";
import ListAllocateShippingUnits from "pages/AllocateShippingUnits/ListAllocateShippingUnits";
import AuthSSO from "pages/Authentication/AuthSSO";
import ForgetPasswordPage from "pages/Authentication/ForgetPassword";
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/Logout";
import Register from "pages/Authentication/Register";
import UserProfile from "pages/Authentication/UserProfile";
import CreateBloodCollectionOrderPage from "pages/BloodCollectionOrder/CreatePage";
import DetailBloodCollectionOrderPage from "pages/BloodCollectionOrder/DetailPage";
import CreateBus from "pages/BusManagement/CreateBus";
import ListBus from "pages/BusManagement/ListBus";
import ChangePassword from "pages/ChangePassword/ChangePassword";
import Dashboard from "pages/Dashboard";
import ListHistoryScan from "pages/HistoryScanTheRow/ListHistoryScan";
import ListHoliday from "pages/Holiday/ListHoliday";
import HubManagement from "pages/HubManagement";
import CreateHub from "pages/HubManagement/createHub";
import UpdateHub from "pages/HubManagement/updateHub";
import Import from "pages/ImportManagement/Import";
import ListImport from "pages/ImportManagement/ListImport";
import ManageNewSendOrderScanTotalPage from "pages/ManageNewSendOrderScanTotal/index-v2";
import ManageOrdersPage from "pages/ManageOrders";
import ManageTransferOrdersPage from "pages/ManageTransferOrders";
import TransferOrderPage from "pages/ManageTransferOrders/TransferOrderPage";
import MyOrderPage from "pages/MyOrders";
import DistrictMyOrderPage from "pages/MyOrders/DistrictOrders/OrderPage";
import HCMMyOrderPage from "pages/MyOrders/HCMOrders/OrderPage";
import MyOrderDetailPage from "pages/MyOrders/OrderDetail/OrderDetailPage/OrderDetailPage";
import MyOrderPageV2 from "pages/MyOrders/OrdersV2/MyOrderPageV2";
import DistrictOrderPage from "pages/Orders/DistrictOrders/OrderPage";
import HCMOrderPage from "pages/Orders/HCMOrders/OrderPage";
import OrderDetailPage from "pages/Orders/OrderDetail/OrderDetailPage/OrderDetailPage";
import OrderPageV2 from "pages/Orders/OrdersV2/OrderPageV2";
import OrderStatistic from "pages/OrderStatistic";
import PaymentMethodPage from "pages/PaymentMethod";
import PhaseOrderDetailPage from "pages/PhaseScanTheRow/PhaseOrderDetailPage/PhaseOrderDetailPage";
import PhaseScanTheRow from "pages/PhaseScanTheRow/PhaseScanTheRow";
import InstructionsDeleteAccountGRunner from "pages/PrivacyNotice/GRunner/InstructionsDeleteAccountGRunner";
import ProductPage from "pages/Product";
import ListReport from "pages/ReportManagement/ListReport";
import StatisticalReportDocument from "pages/ReportManagement/StatisticalReportDocument";
import RouteCollectorPage from "pages/RouteCollector/ListRoute";
import CreateShippingUnit from "pages/ShippingUnitManagement/CreateShippingUnit";
import ListShippingUnit from "pages/ShippingUnitManagement/ListShippingUnit";
import TimeslotPage from "pages/Timeslot";
import TimeslotCollectorPage from "pages/TimeslotCollector";
import ListTransportLocalitiesReceive from "pages/TransportLocalities/ListTransportLocalitiesReceive";
import ListTransportLocalitiesReturn from "pages/TransportLocalities/ListTransportLocalitiesReturn";
import CreateUserProfile from "pages/UserProfile/CreateUserProfile";
import ListUserProfile from "pages/UserProfile/ListUserProfile";
import Pages404 from "pages/Utility/pages-404";
import Pages500 from "pages/Utility/pages-500";
import PagesComingsoon from "pages/Utility/pages-comingsoon";
import PagesMaintenance from "pages/Utility/pages-maintenance";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import CreateCustomer from "../pages/CustomerManagement/CreateCustomer";
import ListCustomer from "../pages/CustomerManagement/ListCustomer";
import ManageOrdersPageActive from "../pages/ManageOrdersActive/Manage-orders-active";
import ListNotification from "../pages/NotificationManagement/ListNotification";
import CreateRouteCollector from "../pages/RouteCollector/CreateRoute";
import CreateRoute from "../pages/RouteManagement/CreateRoute";
import ListRoute from "../pages/RouteManagement/ListRoute";
import ListTransport from "../pages/Transport/ListTransport";
import ListReason from "../pages/Reason/ListReason";
import ListSaleTeams from "pages/SaleTeams/ListSaleTeams";
import TicketManagementPage from "pages/TicketManagement";
import TicketDetailPage from "pages/TicketManagement/TicketDetailPage";
// import RunnerManagementPage from "pages/RunnerManagement";
import ListAuditLogs from "../pages/AuditLogs/ListAuditLogs";
const LoadAllRoute = props => {
  const location = useLocation();
  const navigate = useNavigate();

  const layout = useSelector(state => state?.["Layout"]);
  const { layoutType } = layout;
  const [LayoutTheme, setLayoutTheme] = useState(<HorizontalLayout />);

  useEffect(() => {
    if (layoutType) {
      switch (layoutType) {
        case "horizontal":
          setLayoutTheme(<HorizontalLayout />);
          break;
        case "vertical":
          setLayoutTheme(<VerticalLayout />);
          break;
        default:
          setLayoutTheme(<HorizontalLayout />);
          break;
      }
    }
  }, [layoutType]);

  useEffect(() => {
    if (location?.pathname === "/" && !localStorage.getItem(AUTH_TOKEN)) {
      navigate("/login");
    } else if (location?.pathname === "/" && localStorage.getItem(AUTH_TOKEN)) {
      navigate("/dashboard");
    }

    if (
      ["/login", "/login-dev"].some(x =>
        String(location?.pathname).includes("/login")
      ) &&
      localStorage.getItem(AUTH_TOKEN)
    ) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <React.Fragment>
      <Routes>
        {/* PUBLIC ROUTE */}
        <Route path="/" element={<NonAuthLayout />}>
          <Route index element={<Login />} />
          <Route path="logout" element={<Logout />} />
          <Route path="login" element={<Login />} />
          <Route path="login-dev" element={<Login />} />
          <Route path="sso/callback" element={<AuthSSO />} />
          <Route path="forgot-password" element={<ForgetPasswordPage />} />
          <Route path="register" element={<Register />} />
          <Route path="pages-maintenance" element={<PagesMaintenance />} />
          <Route path="pages-comingsoon" element={<PagesComingsoon />} />
          <Route path="pages-404" element={<Pages404 />} />
          <Route path="pages-500" element={<Pages500 />} />
          <Route
            path="privacy-notice/g-runner/delete-account"
            element={<InstructionsDeleteAccountGRunner />}
          />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>

        {/* PRIVATE ROUTE */}
        <Route path="/" element={LayoutTheme}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          {/* START ORDERS */}
          {/* My Orders */}
          <Route path="my-orders" element={<MyOrderPage />} />
          <Route path="my-orders/hcm-create" element={<HCMMyOrderPage />} />
          <Route
            path="my-orders/district-create"
            element={<DistrictMyOrderPage />}
          />
          <Route path="my-orders/create" element={<MyOrderPageV2 />} />
          <Route
            path="my-orders/:orderDetailId"
            element={<MyOrderDetailPage />}
          />
          {/* Manage Orders */}
          <Route path="manage-orders" element={<ManageOrdersPage />} />
          <Route
            path="manage-orders-active"
            element={<ManageOrdersPageActive />}
          />
          <Route
            path="manage-orders/:orderDetailId"
            element={<OrderDetailPage />}
          />
          <Route
            path="manage-new-send-order-scan-total"
            element={<ManageNewSendOrderScanTotalPage />}
          />
          <Route path="manage-orders/hcm-create" element={<HCMOrderPage />} />
          <Route
            path="manage-orders-active/hcm-create"
            element={<HCMOrderPage />}
          />
          <Route
            path="manage-orders/district-create"
            element={<DistrictOrderPage />}
          />
          <Route
            path="manage-orders-active/district-create"
            element={<DistrictOrderPage />}
          />
          <Route path="manage-orders/create" element={<OrderPageV2 />} />{" "}
          <Route path="manage-orders-active/create" element={<OrderPageV2 />} />{" "}
          <Route
            path="manage-transfer-orders"
            element={<ManageTransferOrdersPage />}
          />
          <Route
            path="manage-transfer-orders/create"
            element={<TransferOrderPage />}
          />
          <Route
            path="manage-transfer-orders/:orderDetailId"
            element={<TransferOrderPage />}
          />
          <Route
            path="manage-transfer-orders/copy/:orderDetailId"
            element={<TransferOrderPage is_copy={true} />}
          />
          {/* E N D ORDERS */}
          {/* Route */}
          <Route path="route/list" element={<ListRoute />} />
          <Route path="route/create" element={<CreateRoute />} />
          {/* Profile */}
          <Route path="profile" element={<UserProfile />} />
          {/* Shipping Unit */}
          <Route path="shipping-unit/list" element={<ListShippingUnit />} />
          <Route path="shipping-unit/create" element={<CreateShippingUnit />} />
          {/* Customer */}
          <Route path="customer/list" element={<ListCustomer />} />
          <Route path="customer/create" element={<CreateCustomer />} />
          {/* Bus */}
          <Route path="bus/list" element={<ListBus />} />
          <Route path="bus/create" element={<CreateBus />} />
          {/* Report Management */}
          <Route path="report-management/list" element={<ListReport />} />
          <Route
            path="report-management/statistic"
            element={<StatisticalReportDocument />}
          />
          {/* Import Management */}
          <Route path="import-management/list" element={<ListImport />} />
          <Route path="import-management/import" element={<Import />} />
          {/* Allocate Shipping Unit */}
          <Route
            path="allocate-shipping-unit/list"
            element={<ListAllocateShippingUnits />}
          />
          {/* List Allocate Runner */}
          <Route path="allocate-runner/list" element={<ListAllocateRunner />} />
          {/* Transport */}
          <Route path="transport/list" element={<ListTransport />} />
          {/* User Profile */}
          <Route path="user-profile/list" element={<ListUserProfile />} />
          <Route path="user-profile/create" element={<CreateUserProfile />} />
          {/* Notification Management */}
          <Route
            path="notification-management/list"
            element={<ListNotification />}
          />
          {/* Reason */}
          <Route path="reason/list" element={<ListReason />} />
          {/* Holiday */}
          <Route path="holiday/list" element={<ListHoliday />} />
          {/* TransportLocalities */}
          {/* Danh sách phân bổ ĐVVC theo vùng cho đơn nhận mẫu */}
          <Route
            path="transport-localities-receive/list"
            element={<ListTransportLocalitiesReceive />}
          />
          {/* Danh sách phân bổ ĐVVC theo vùng cho đơn trả KQ*/}
          <Route
            path="transport-localities-return/list"
            element={<ListTransportLocalitiesReturn />}
          />
          {/* Sales Team */}
          <Route path="sale-teams" element={<ListSaleTeams />} />
          {/* Ticket Management */}
          <Route path="ticket-management" element={<TicketManagementPage />} />
          <Route path="ticket-management/:ticketId" element={<TicketDetailPage />} />
          <Route path="my-tickets" element={<TicketManagementPage />} />
          <Route path="my-tickets/:ticketId" element={<TicketDetailPage />} />
          {/* Runner Management */}
          {/* <Route path="runner-management" element={<RunnerManagementPage />} /> */}
          {/* Audit Logs */}
          <Route path="audit-logs" element={<ListAuditLogs />} />
          {/* Scan Order */}
          <Route path="scan-barcode" element={<ScanRow />} />
          <Route path="scan-send-barcode" element={<ScanSendOrderRow />} />
          <Route path="history-scan-barcode" element={<ListHistoryScan />} />
          <Route path="phase-scan-barcode" element={<PhaseScanTheRow />} />
          <Route
            path="phase-scan-barcode/:phaseOrderScanDetailId"
            element={<PhaseOrderDetailPage />}
          />
          <Route path="hub/list" element={<HubManagement />} />
          <Route path="hub/create" element={<CreateHub />} />
          <Route path="hub/:id" element={<UpdateHub />} />
          <Route path="timeslot/list" element={<TimeslotPage />} />
          <Route path="order-statistic" element={<OrderStatistic />} />
          <Route path="payment-method" element={<PaymentMethodPage />} />
          <Route
            path="timeslot-collector/list"
            element={<TimeslotCollectorPage />}
          />
          <Route path="test-pack" element={<ProductPage />} />
          <Route path="route-collector/list" element={<RouteCollectorPage />} />
          <Route
            path="route-collector/create"
            element={<CreateRouteCollector />}
          />
          <Route
            path="allocate-collector/list"
            element={<ListAllocateCollector />}
          />
          <Route
            path="collection-order/create"
            element={<CreateBloodCollectionOrderPage />}
          />
          <Route
            path="collection-order/:orderId"
            element={<DetailBloodCollectionOrderPage />}
          />
        </Route>

        <Route path="*" element={<Pages404 />} />
      </Routes>
    </React.Fragment>
  );
};

export default LoadAllRoute;
